module.exports = __webpack_public_path__ + "img/receipt31.d6503480.svg";